import {
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';
import { MAIN_THEME } from '@styles';

export const amendmentsTableHeaders: Record<string, EnhancedTableHeader> = {
  referenceNumber: {
    name: 'referenceNumber',
    title: 'Reference Number',
    type: EnhancedTableHeaderType.Link,
    openUrlInNewTab: false,
    urlTemplate: '/production/amendments/{id}'
  },
  amendmentType: {
    name: 'amendmentType',
    title: 'Amendment Type',
    type: EnhancedTableHeaderType.Text
  },
  amendmentSubType: {
    name: 'amendmentSubType',
    title: 'Amendment Sub-Type',
    type: EnhancedTableHeaderType.Text
  },
  amendmentEffectiveDate: {
    name: 'amendmentEffectiveDate',
    title: 'Amendment Effective Date',
    type: EnhancedTableHeaderType.Date
  },
  status: {
    name: 'status',
    title: 'Status',
    type: EnhancedTableHeaderType.ColoredText,
    textColorConfig: {
      New: MAIN_THEME.color.blue,
      'In Progress': MAIN_THEME.color.orange,
      Confirmed: MAIN_THEME.color.green,
      Cancelled: MAIN_THEME.color.red
    }
  },
  createdOn: {
    name: 'createdOn',
    title: 'Created On',
    type: EnhancedTableHeaderType.Date
  }
};
